<template lang="pug">
  section.ranking.ranking-interior
    h3
      span Tiempos del rally nacional
      small presentado por
        img(src="content/logo-citroen.png")

    .cols(v-if="!pending.trophies")
      .col
        h4(v-if="trophy") {{trophy.title}} <br>
          small {{trophy.undertitle}}
      .col.right
        small Fuente:
          strong Anare
    .cols
      .col
        PrimeSelector(v-if="primes" :primes="primesByTrophy")
      .col
        TimeSelector
    .table
      .title.row.wraprow
        .col
          span Pos
        .col
          span No.
        .col
          span Piloto/Navegante
        .col
          span Marca
        .col
          span(v-if="activetype === 'tiemposPrime'" ) T. Neto
          span(v-if="activetype === 'tiemposAcumulados'" ) T. Acum.
        .col
          span Vel. Prom.
      .data
        //- h3 {{readypositions}}
        .loading(v-if="!readypositions")
          h3 Cargando...
        .carouselwrapper(v-if="readypositions")
          //- code {{positions[0].PrimeId}}
          //- code {{activeprime}}
          //- code {{positions[0].PrimeId === activeprime}}

          carousel.carous(:per-page-custom="[[320, 1]]", :per-page="1", navigationEnabled=false ,  loop=true ref="carous")
            slide.cli(v-for="(cclass, index) in carclasses" :key="index")
              h3 {{cclass}}
              .wrapwraprow(v-for="(position, index) in positions" v-if="position.PrimeId === activeprime")
                //- code {{position.type === activetype && position.carclass === cclass}}
                Row.wraprow(
                :posicion="position.position",
                :numeroauto="position.carnumber",
                :piloto="position.pilots",
                :marca="position.brand",
                :tiemponeto="position.nettime",
                :tiempoacumulado="position.totaltime",
                :velocidadpromedio="position.averagespeed",
                v-if="position.type === activetype && position.carclass === cclass")

</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import Row from '@/components/Row'
import PrimeSelector from '@/components/PrimeSelector'
import TimeSelector from '@/components/TimeSelector'

export default {
  created(){
    this.getTrophies(),
    this.getPrimes(),
    this.getPositions()
  },
  watch: {
    readypositions(val){
      console.log(val)
    }
  },
  components: {
    Row,
    PrimeSelector,
    TimeSelector
  },
  computed: {
    ...mapGetters([
      'primesByTrophy',
      'positionsByPrime',
    ]),
    ...mapState({
      positions: state => state.positions,
      primes: state=> state.primes,
      trophies: state=> state.trophies,
      trophy: state=> state.trophy,
      pending: state => state.pending,
      error: state => state.error,
      activeprime: state => state.activePrime,
      activetype: state => state.activeType,
      carclasses: state => state.carclasses,
      readypositions: state => state.readypositions,
      readytrophies: state => state.readytrophies,
      readyprimes: state => state.readyprimes,
    }),

  },
  methods: {
    ...mapActions([
      'getTrophies',
      'getPrimes',
      'getPositions'
    ])
  }
}
</script>
<style lang="scss" scoped>
  .carouselwrapper{
    max-width: 98vw;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  .carouselwrapper /deep/ .VueCarousel-pagination{
    margin-top: -20px;
  }

  .ranking-interior{
    padding: 5px;
  }
  h3{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0;
    font-weight: 900;
    font-style: italic;
    text-transform: uppercase;
    span{
      font-size: 1.2rem;
    }
    small{
      font-size: 1rem;
      display: flex;
      align-items: center;
      img{
        max-height: 40px;
      }
    }
  }
  h1{
    font-weight: bold;
    text-align: center;
    color: lighten(black, 50%);
  }

  .cols{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    @media (max-width: 900px){
      grid-template-columns: repeat(1, 1fr);
    }
    .col{
      overflow: hidden;
      padding: 0.3rem 0.5rem;
      &.right{
        display: flex;
        justify-content: flex-end;
      }
    }
  }


  .title{
    border-bottom: 1px solid #c0c0c0;
  }
  .data{
    .wrapwraprow{
      .wraprow{
        border-bottom: 1px solid #c0c0c0;
      }
      &:nth-child(odd){
        // background-color: lighten(black, 70%);
      }
    }
  }

  .wraprow{
    padding: 2px;
    display: grid;
    grid-template-columns: 7% 7% 45% repeat(3, 1fr);
    align-items: center;
    .col{
      font-size: 14px;
      line-height: 14px;
      padding: 0;
      margin: 0;
      text-align: center;
    }
  }

</style>


